import { useState } from "react";

type Props = {
  initialPage?: number;
  initialPerPage?: number;
};

export const usePagination = ({
  initialPage = 1,
  initialPerPage = 10,
}: Props) => {
  const [page, setPage] = useState(initialPage);
  const [count, setCount] = useState(0);
  const [countPerPage, setCountPerPage] = useState(initialPerPage);

  return { page, setPage, count, setCount, countPerPage, setCountPerPage };
};
